import {
  HttpClient
} from '@angular/common/http';
import {
  Injectable
} from '@angular/core';
import {
  Observable
} from 'rxjs';
import {
  GlobalSettings
} from './global.settings';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(
    private httpClient: HttpClient) {

  }

  /* --------- Functionality to fetch environment configuration start-------- */

  getConfiguration(): Promise<any> {

    return (this.httpClient.get('./assets/json/envConfiguration.json')
      .toPromise()
      .then(data => {
        Object.assign(this, data);
        const configuration = data[window.location.hostname];
        GlobalSettings.setConfiguration(configuration, false);
      })
    )

  }

  /* --------- Functionality to fetch environment configuration end -------- */

  public setConfig() {
    this.getConfigurations().subscribe(data => {
      const configuration = data[window.location.hostname] ? data[window.location.hostname] : data['unifiedfrost-dev.learningmate.co'];
      GlobalSettings.setConfiguration(configuration, false);
    });
  }

  /* --------- Functionality to fetch environment configuration start - not in use as async -------- */

  public getConfigurations(): Observable<any> {
    try {
      return this.httpClient.get('./assets/json/envConfiguration.json');
    } catch (err) {
      console.log('Error fetching configurations')
    }
  }

  /* --------- Functionality to fetch environment configuration end -------- */

}
